<template>
    <el-form :model="roleInfo" :rules="roles" ref="roleInfo" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center" v-if="isAdd">
                <div class="form-label">
                    <label class="required">权限来源</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="roleSrcFlag">
                        <el-radio-group v-model="roleSrcFlag">
                            <el-radio :label=1>按职责权限</el-radio>
                            <el-radio :label=0>无</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="isAdd && roleSrcFlag == 1">
                <div class="form-label">
                    <label class="required">职责权限</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="srcTplName">
                        <el-input class="bottom-line width-2x" v-model="roleInfo.srcTplName" :disabled="true"></el-input>
                        <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择职责权限" @click="tplComRoleDlg()"></i>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">岗位名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="name">
                        <el-input v-model="roleInfo.name" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>岗位编码</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="code">
                        <el-input v-model="roleInfo.code" class="width-2x" type="text" auto-complete="off"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>描述</label>
                </div>
                <div class="form-value">
                    <el-input class="width-2x" type="textarea" :rows="2" placeholder="请输入内容" v-model="roleInfo.desc"></el-input>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    //
    import {Utils} from '../../app.base'
    import {Vue} from '../../app.vues'

    import SwbMerchtTplRoleListSelect from './MerchtTplRoleListSelect'

    Vue.regist(SwbMerchtTplRoleListSelect);
    //
    export default {
        name: 'swb-save-com-role',
        desc: '保存公司岗位',
        props: ['item', 'isAdd', 'bizUnitType'],
        data: function () {
            let self = this;
            let validateNull = function (rule, value, callback) {
                if (Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            let validateSrcTplId = function (rule, value, callback) {
                if (Utils.isNoB(value) && self.roleSrcFlag == 1) {
                    callback(new Error('请选择模板岗位'));
                } else {
                    callback();
                }
            };
            return {
                roleInfo: {
                    name: null,
                    code: null,
                    desc: null,
                    srcTplId: null,
                    srcTplVer: null
                },
                roleSrcFlag: 1,
                roles: {
                    name: [{validator: validateNull, trigger: 'blur'}],
                    srcTplName: [{validator: validateSrcTplId, trigger: 'change'}]
                }
            }
        },
        created: function () {
            let item = this.item;
            if (!Utils.isNoB(item) && item.id != null) {
                this.roleInfo = item;
            }
        },
        methods: {
            tplComRoleDlg() {
                let self = this;
                let filter = {
                    bizUnitTypeX: this.bizUnitType  // 机构的业务单元类型
                };
                let theDlg = Vue.$showDialog({
                    title: '职责权限选择',
                    width: 1200,
                    height: 700,
                    showCloseBtn: true,
                    template: '<swb-mercht-tpl-role-list-select :filter="filter" :radioFlag="true" ref="swb_tpl_com_role_list_select"></swb-mercht-tpl-role-list-select>',
                    data: {
                        filter: filter
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_tpl_com_role_list_select.getDlgResult() || {};
                        if (result.type == 'info') {
                            let tpl = result.data;
                            //
                            let roleInfo = self.roleInfo;
                            //
                            roleInfo.srcTplId = tpl.id;// /
                            roleInfo.srcTplName = tpl.confName;
                            roleInfo.name = tpl.realName;
                            roleInfo.desc = tpl.desc;
                            //
                            self.roleInfo = Utils.merge({}, roleInfo);
                            theDlg.close();
                        } else {
                            Toast.show(result.message);
                        }
                        return false;
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['roleInfo'].validate(function (valid) {
                    if (valid) {
                        let roleInfo = self.roleInfo || {};
                        let roleSrcFlag = self.roleSrcFlag;
                        if (roleSrcFlag == 1) {
                            if (Utils.isNoB(roleInfo.srcTplId)) {
                                result.type = "warn";
                                result.message = "请选择模板岗位";
                                return result;
                            }
                        } else {
                            roleInfo.srcTplId = null;
                        }
                        result.type = "info";
                        result.data = roleInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/authx/SaveComRole.vue